import React, { FC } from 'react';
import styles from './ImageActions.module.scss';
import { CloseOutlined, CheckOutlined } from '@ant-design/icons';
import { Switch } from 'antd';

type Props = {
  label: string;
  checked: boolean;
  onClick: () => void;
};

export const ActionToggle: FC<Props> = ({ label, checked, onClick }) => {
  return (
    <div className={styles.actions}>
      <Switch
        className={styles.switch}
        size='small'
        checkedChildren={<CheckOutlined />}
        unCheckedChildren={<CloseOutlined />}
        checked={checked}
        onClick={onClick}
      />
      <label>{label}</label>
    </div>
  );
};

export default ActionToggle;
